import $ from 'jquery';
import 'slick-carousel';
import './slick.scss';
import './slick-theme.scss';
import './slider.scss';
import './slider-wcag.scss';

$(document).ready(function() {
    $('#local_banners').slick({
        slidesToShow: 1,
        dots: true,
        arrows: true,
        infinite: true,
        speed: 500,
        autoplay: true,
        autoplaySpeed: 3000,
        fade: true,
        cssEase: 'linear'
    });
    $('.js_slider').slick({
        dots: false,
        arrows: false,
        infinite: true,
        speed: 500,
        autoplay: true,
        autoplaySpeed: 5000,
        fade: true,
        cssEase: 'linear'
    });
    $('#useful_links').slick({
        infinite: true,
        slidesToShow: 5,
        dots: false,
        slidesToScroll: 1,
        prevArrow: '<button type="button" class="slick-prev inline-icon-arrow-right inline-icon-arrow-right_left">Previous</button>',
        nextArrow: '<button type="button" class="slick-next inline-icon-arrow-right">Next</button>',
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 3,
                    arrows: false,
                }
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2,
                    arrows: false,
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    arrows: false,
                }
            }
        ]
    });

    $('#js_information').slick({
        slidesToShow: 3,
        slidesToScroll: 3,
        dots: false,
        prevArrow: '<button type="button" class="slick-prev inline-icon-arrow-right inline-icon-arrow-right_left">Previous</button>',
        nextArrow: '<button type="button" class="slick-next inline-icon-arrow-right">Next</button>',
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 3,
                    arrows: false,
                }
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2,
                    arrows: false,
                }
            },
            {
                breakpoint: 610,
                settings: {
                    arrows: false,
                    slidesToShow: 1,
                    slidesToScroll: 1,
                }
            }
        ]
    });
    $('.js_gallery_slider').slick({
        infinite: true,
        slidesToShow: 4,
        slidesToScroll: 4,
        dots: false,
        prevArrow: '<button type="button" class="slick-prev inline-icon-arrow-right inline-icon-arrow-right_left">Previous</button>',
        nextArrow: '<button type="button" class="slick-next inline-icon-arrow-right">Next</button>',
        responsive: [
            {
                breakpoint: 1070,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 3,
                    arrows: false,
                }
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2,
                    arrows: false,
                }
            },
            {
                breakpoint: 540,
                settings: {
                    arrows: false,
                    slidesToScroll: 1,
                    slidesToShow: 1,
                }
            }
        ]
    });
});
